<nb-card [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="giant">
  <app-datatable
    [columns]="columns"
    [rows]="branchChampion"
    [searchControlSettings]="searchControlSettings"
    [searchable]="searchable"
    (filterChange)="onFilterChange($event)"
    [isSingleSelectView]="true"
  >
  </app-datatable>
</nb-card>
